import React, { useEffect } from "react";
import GModal from "components/ui/modal/Modal";
import { useTranslation } from "react-i18next";
import { Box, Flex, Stack } from "@chakra-ui/react";
import MultiSelect from "components/ui/multiSelect/MultiSelect";
import { getBranches } from "features/management/branches/services/branchesService";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import GButton from "components/ui/button/Button";
import { useParams } from "react-router-dom";
import {
  addOutOfStockbranche,
  getOutOfStock,
} from "../../services/modifiersOptionsCustomService";
import { useToast } from "@chakra-ui/react";

const OutOfStockModal = ({ onClose }) => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getBranches());
  }, [dispatch]);

  const branches = useSelector((state) => state.branches);

  const { handleSubmit, control, getValues, watch, setValue, register } =
    useForm();

  const id = useParams();
  //console.log(id.modifiersOptionId)

  const toast = useToast({
    position: "top",
    duration: 3000,
    status: "success",
  });

  const toast2 = useToast({
    position: "top",
    duration: 3000,
    status: "error",
  });

  return (
    <GModal
      onClose={onClose}
      modalHeader={t("pages.modifiers_options.out_Of_Stock")}
      modalContent={
        <Box p={4}>
          <form
            onSubmit={handleSubmit((values) => {
              values.UserId = localStorage.getItem("userId");

              values.BranchId = values.BranchId?.BranchId;
              values.ModiferOptionId = id.modifiersOptionId;
              if (values.BranchId === undefined) {
                toast2({
                  description: t("pages.DailyRestrictions.searchvalidation"),
                });
              } else {
                dispatch(addOutOfStockbranche(values)).then((_) => {
                  toast({ description: t("pages.combos.combo_created") });
                  dispatch(getOutOfStock(id.modifiersOptionId));
                  onClose();
                });
              }
            })}
          >
            <Stack spacing={6}>
              <MultiSelect
                title={t("pages.combos.branches")}
                data={
                  branches.data &&
                  branches.data.map((el) => ({
                    ...el,
                    label: el.BranchName,
                    value: el.BranchId,
                  }))
                }
                isMulti={false}
                isRequired
                onChange={(e) => setValue("BranchId", e)}
              />

              <Flex gap={4}>
                <GButton
                  type="submit"
                  title={t("general.save")}
                  bg="primary"
                  color="light"
                  border="1px solid transparent"
                  isLoading={branches.isLoading}
                  hover={{
                    color: "primary",
                    borderColor: "primary",
                    bg: "none",
                  }}
                />
                <GButton
                  title={t("general.close")}
                  onClick={onClose}
                  bg="red.600"
                  border="1px solid transparent"
                  color="light"
                  isLoading={branches.isLoading}
                  hover={{
                    color: "red.600",
                    borderColor: "red.600",
                    bg: "none",
                  }}
                />
              </Flex>
            </Stack>
          </form>
        </Box>
      }
    />
  );
};

export default OutOfStockModal;
